import { useContext } from "react";
import { errorAlertContext } from "./errorAlertContext";

export function useErrorAlert() {
  const context = useContext(errorAlertContext);
  if (!context) {
    throw new Error("useErrorAlert must be used within a ErrorAlertProvider");
  }
  return context;
}
